import React from 'react'
import {Svg} from '@modifi/ui'

export default ({...props}) => (
  <Svg viewBox="0 0 150 150" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#51565C"
        strokeWidth="3.5"
        d="M145 115.82l-3.528 4.023H38.292l-3.528-4.022v-1.49H145zM41.93 114.33h95.905V52.599H41.929z"
      />
      <g stroke="#FFF" strokeWidth="2">
        <path
          fill="#53A2D9"
          d="M4.551 44.433h15.305v15.304H4.55V44.433zM19.433 29h15.304v15.304H19.433V29z"
        />
        <path
          fill="#7BB835"
          d="M19.433 60.417h15.304v15.305H19.433V60.417zM34.315 44.433h15.304v15.304H34.315V44.433z"
        />
        <path
          fill="#15539F"
          d="M49.197 60.417H64.5v15.305H49.197V60.417zM34.315 75.85h15.304v15.305H34.315V75.85z"
        />
      </g>
      <path
        fill="#51565C"
        fillRule="nonzero"
        d="M75.57 88.121H57.362v-2.636h18.263l-5.274-5.987 1.68-1.545L79.12 86a1.17 1.17 0 0 1 0 1.541l-7.089 8.049-1.68-1.545 5.219-5.925z"
      />
      <g stroke="#51565C" strokeWidth="3">
        <path d="M93.465 76.921h25.86M93.465 86.291h25.86M93.465 95.661h25.86" />
      </g>
    </g>
  </Svg>
)
